import _ from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'translations/messages';

const RoleTypeLabel = ({ roleType }) => {
  const key = _.camelCase(roleType);

  if (globalMessages[key]) {
    return <FormattedMessage {...globalMessages[key]} />;
  }

  return roleType;
};

export default RoleTypeLabel;
